export const DEFAULT_LOCKED_TIMESHEET_MESSAGE = `Please note: This timesheet cannot be changed.
    Please contact your Consultant if you have any questions.`;
export const TIMESHEET_CONNECTION_ERROR = 'Timesheet connection error. Please try a few minutes later.';
export const TIMESHEET_CREATION_ERROR = 'Timesheet creation error. Please try a few minutes later.';
